import React from "react";
import styles from "./PartForm.module.css";

/**
 * Controlled form: partNumber, description, category, notes.
 * @param {{ partNumber: string, description: string, category: string, notes: string }} values
 * @param {(field: string, value: string) => void} onFieldChange
 */
function PartForm({ values, onFieldChange, disabled = false, idPrefix = "part" }) {
  const p = (name) => `${idPrefix}-${name}`;

  return (
    <div className={styles.grid}>
      <div className={styles.field}>
        <label className={styles.label} htmlFor={p("partNumber")}>
          Part number <span className={styles.req}>*</span>
        </label>
        <input
          id={p("partNumber")}
          className={styles.input}
          value={values.partNumber ?? ""}
          onChange={(e) => onFieldChange("partNumber", e.target.value)}
          disabled={disabled}
          autoComplete="off"
          placeholder="e.g. ABC-123-X"
        />
        <p className={styles.hint}>Letters, digits, and hyphens only.</p>
      </div>
      <div className={styles.field}>
        <label className={styles.label} htmlFor={p("description")}>
          Description
        </label>
        <input
          id={p("description")}
          className={styles.input}
          value={values.description ?? ""}
          onChange={(e) => onFieldChange("description", e.target.value)}
          disabled={disabled}
          autoComplete="off"
          placeholder="Title or short description"
        />
      </div>
      <div className={styles.field}>
        <label className={styles.label} htmlFor={p("category")}>
          Category
        </label>
        <input
          id={p("category")}
          className={styles.input}
          value={values.category ?? ""}
          onChange={(e) => onFieldChange("category", e.target.value)}
          disabled={disabled}
          autoComplete="off"
          placeholder="Any category label"
        />
      </div>
      <div className={`${styles.field} ${styles.fieldFull}`}>
        <label className={styles.label} htmlFor={p("notes")}>
          Notes
        </label>
        <textarea
          id={p("notes")}
          className={styles.textarea}
          value={values.notes ?? ""}
          onChange={(e) => onFieldChange("notes", e.target.value)}
          disabled={disabled}
          rows={4}
          placeholder="Optional notes"
        />
      </div>
    </div>
  );
}

export default PartForm;
